(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('ConfirmPublishModalController', ConfirmPublishModalController);

        ConfirmPublishModalController.$inject = ['$scope', '$uibModal', '$uibModalInstance', 'toastr'];

    function ConfirmPublishModalController($scope, $uibModal, $uibModalInstance, toastr) {
        var vm = this;

        vm.confirm = function() {
            $uibModalInstance.close(true);
        }

        vm.closeModal = function() {
            $uibModalInstance.dismiss();
        }

    }

})();
